import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const addInvoiceCode2Transaction = createAction(Constants.ADD_INVOICE_CODE_2_TRANSACTION.REQUEST, (datas) => (datas));
export const clearState = createAction(Constants.CLEAR_ADD_INVOICE_CODE_2_TRANSACTION,  () => ({}));

